define.alias("shared/components/shared/color-picker/swatches", "media/components/shared/color-picker/swatches");